var React = require('react');

function LeafInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_19_347)","key":0},React.createElement("path",{"d":"M17.9609 0.737007L17.9996 0.723845L17.9503 0.733716C14.9344 -0.230417 12.1195 -0.253451 8.97672 0.733716C5.83395 1.72088 4.04135 2.92687 0.0648528 4.25955H0.0313624L-0.00741577 4.27271L0.0419377 4.26284C3.0578 5.22862 5.87272 5.25 9.01373 4.26284C12.1547 3.27567 13.9491 2.07133 17.9274 0.737007H17.9609Z","fill":"#A8C855"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_19_347"},React.createElement("rect",{"width":"18","height":"5","fill":"white"})))]);
}

LeafInline.defaultProps = {"width":"18","height":"5","viewBox":"0 0 18 5","fill":"none"};

module.exports = LeafInline;

LeafInline.default = LeafInline;
